import { EventEmitter, Injectable, Output } from '@angular/core';
import { RootScopeService } from './root-scope.service';
import { ApiService } from './api.service';
import { GenesysCloudService } from './genesys-cloud.service';
import * as Constants from '../models/Constants';
import { CallCustomerAttributes } from '../models/customer.model';
import { FormControl, Validators } from '@angular/forms';
import { LogService } from './log.service';


@Injectable({
  providedIn: 'root'
})
export class OtcService {


  @Output()
  goToCustomerOverviewPageEmitter: EventEmitter<any> = new EventEmitter();

  otcLenght: number = 6;
  fileName: string = 'otc_service';
  openCountryCodeDialog: boolean = false;
  oneTimeCode = new FormControl('', [
    Validators.required,
    Validators.minLength(this.otcLenght),
    Validators.maxLength(this.otcLenght),
    Validators.pattern(/^\d+$/)
  ]);

  constructor(public rootScope: RootScopeService,
    public apiService: ApiService,
    public genesysService: GenesysCloudService,public logger:LogService
  ) { }


  getOTCConfig() {
    const configData = this.rootScope.activeCustTab?.otcData?.otcConfigData;

    if (Object.keys(configData).length === 0) {
      this.getOTCConfigFromServer();
    }
  }

  /* istanbul ignore next */
  getOTCConfigFromServer() {
    this.rootScope.activeCustTab.otcData.deliveryMethodApiFail = false;
    const clientId = this.rootScope.activeCustTab.clientId;

    this.apiService.getOTCConfig(clientId).subscribe({
      next: (res: any) => {
        const data = res?.data;

        if (data) {
          this.logger.debugLogs("OTC Config Response:", this.fileName);
          this.rootScope.activeCustTab.otcData.otcConfigData = data;
          const deliveryMethods = data?.deliveryMethods || [];
          const hasDeliveryMethods = deliveryMethods?.length > 0;
          this.rootScope.activeCustTab.otcData.deliveryMethodConfigMiss = !hasDeliveryMethods;
          this.rootScope.activeCustTab.otcData.step1Active = hasDeliveryMethods;

          if(hasDeliveryMethods) {
            let arr = deliveryMethods?.find((m: any) => m?.type == Constants.OTC_MODES.TEXT && m?.details && m?.details?.length > 0);
            if(arr?.details?.length > 0){
               this.getPhoneNumberStatus(arr?.details);
            }
          }

          const methodsWithData = deliveryMethods?.filter((m: any) => m?.details && m?.details?.length > 0);
          this.handlePreselectionOfDeliveryMethod(methodsWithData);

        } else {
          this.rootScope.activeCustTab.otcData.deliveryMethodConfigMiss = true;
        }
      },
      error: (err) => {
        this.rootScope.activeCustTab.otcData.deliveryMethodApiFail = true;   
        this.logger.errorLogs(JSON.stringify(err),this.fileName);}
    })
  }

  getPhoneNumberStatus(phoneNumberList: any[], status?: string) {
    let payload :any[] = [];
    phoneNumberList?.forEach((item: any) => {
      payload.push({
        "mblNmbrFrmtCd": item?.countryCode,
        "phoneNumber": item?.phoneNumber
      });
    });

    this.apiService.getPhoneNumberStatus(payload).subscribe({
      next: (res: any) => {
        const data = res?.data;
        if (data) {
          if (data?.length > 0) {

            
            /**Handling case of selected phone number was invalid country code .After selecting correct cc , updating the existing object */
            if(status == Constants.PHONE_STATUS_CHECK_REASON.COUNTRY_CODE_CHANGE){
              this.rootScope.activeCustTab.otcData.step2Active = true;

                const foundDetail = this.rootScope.activeCustTab.otcData.phoneNumberStatusList?.find((item: any) => {
                  return item?.phoneNumber === phoneNumberList[0]?.phoneNumber;
               })
               if(foundDetail){
                  this.rootScope.activeCustTab.otcData.status = data[0]?.responseCode;
               }
            }
            else{
              // data[2].responseCode = "OPTOUT000100";
              this.rootScope.activeCustTab.otcData.phoneNumberStatusList = data;
            }
          }
        }

      },
      error: (err) => {
        this.logger.errorLogs(JSON.stringify(err),this.fileName);
        if(status == Constants.PHONE_STATUS_CHECK_REASON.COUNTRY_CODE_CHANGE){
          this.rootScope.activeCustTab.otcData.step2Active = true;
        }
      }
    });
  }

  /**
   * CCR1-7261
   * Below method generate the OTC in which backend API interacting with S-Auth API.
   * We have done error handling for various scenarios.
   * @author - Sultan Khan
   */
  generateOTC() {
     const otcData = this.rootScope.activeCustTab?.otcData;

     if (otcData) {
      otcData.unStopPhoneNumberStatusApiSuccess = false;
      otcData.unStopPhoneNumberStatusApiFailure = false;
      otcData.unStopPhoneNumberStatusApiFailureDetails = '';
    }

      let countryCode = this.rootScope.activeCustTab.otcData.selectedCountryCode; 
        
        if(countryCode == Constants.COUNTRY_CODES.United_Kingdom){
          countryCode = Constants.COUNTRY_CODES.Great_Britain;
        }
    
    this.rootScope.activeCustTab.otcData.notEligiblePhoneNumber = false;
    this.rootScope.activeCustTab.otcData.generateOTCApiFailure = false;
    this.rootScope.activeCustTab.otcData.otcDenied = false;
    this.rootScope.activeCustTab.otcData.generateOTCInProgress = true;


    const clientId = this.rootScope.activeCustTab.clientId;
    const mode = this.rootScope.activeCustTab.otcData.selectedDeliveryMethod?.type; // email or text
    const locale = this.rootScope.activeCustTab?.otcData?.otcConfigData?.prefferedLocal;

    let param: any;

    if (mode == Constants.OTC_MODES.EMAIL) {
      param = {
      clientId,
      locale,
      emailAddress: this.rootScope.activeCustTab?.otcData?.selectedEmail,
      mode
      };
    } else if (mode == Constants.OTC_MODES.TEXT) {
      const mobileNumber = this.rootScope.activeCustTab?.otcData?.selectedPhoneNumber;

      /** The feature used in the provided code snippet JSON Object is called shorthand property names. 
       * This feature allows us to create objects more concisely when the property name is the same as the variable name
       * */
      param = {
      clientId,
      mobileNumber,
      locale,
      countryCode,
      mode
      };
      
    }
    this.logger.infoLogs('OTC Email Param:', this.fileName);
    this.apiService.generateOTC(param).subscribe({
      next: (res: any) => {
      const httpStatusCode = res?.httpStatusCode;

      if (httpStatusCode == Constants.GENERATE_OTC_API_RESPONSE.STATUS_CODE_TWO_HUNDRED) {
          this.rootScope.activeCustTab.otcData.sendOTCSuccess = true;
          this.rootScope.activeCustTab.otcData.generateOTCInProgress = false;
          this.rootScope.activeCustTab.otcData.step3Active = true;
        }
        this.logger.debugLogs('OTC Generation Response:',this.fileName);
      },
      error: (err) => {
        this.rootScope.activeCustTab.otcData.generateOTCInProgress = false;
        if (err?.error?.httpStatusCode == Constants.GENERATE_OTC_API_RESPONSE.STATUS_CODE_FIVE_HUNDRED && err?.error?.message == Constants.GENERATE_OTC_API_RESPONSE.LOCKED) {
          this.rootScope.activeCustTab.otcData.sendOTCSuccess = true;
        } else if (err?.error?.httpStatusCode == Constants.GENERATE_OTC_API_RESPONSE.STATUS_CODE_FIVE_HUNDRED && err?.error?.message == Constants.GENERATE_OTC_API_RESPONSE.NOT_ELIGIBLE) {
          this.rootScope.activeCustTab.otcData.notEligiblePhoneNumber = true;
        } else if (err?.error?.httpStatusCode == Constants.GENERATE_OTC_API_RESPONSE.STATUS_CODE_FIVE_HUNDRED && err?.error?.message == Constants.GENERATE_OTC_API_RESPONSE.DENIED) {
          this.rootScope.activeCustTab.otcData.otcDenied = true;
        } else {
          this.rootScope.activeCustTab.otcData.generateOTCApiFailure = true;
        }
        this.logger.errorLogs(JSON.stringify(err),this.fileName);
      }
    })
  }

/**
 * Below method validate the OTC from S-Auth Api.
 * @param otc 
 * @author - Sultan Khan
 */
  validateOTC(otc: any) {
    this.rootScope.activeCustTab.otcData.validateOtcFail = false;
    this.rootScope.activeCustTab.otcData.validateOtcLocked = false;
    this.rootScope.activeCustTab.otcData.validateOtcApiFailure = false;
    this.rootScope.activeCustTab.otcData.otcExpired = false;
    this.rootScope.activeCustTab.otcData.validateOTCApiProcessing = true;
    
    const clientId = this.rootScope.activeCustTab.clientId;
    this.logger.infoLogs('OTC Validation Param:',this.fileName);
    this.apiService.validateOTC(clientId, otc).subscribe({
      next: (res: any) => {
       
        if (res?.httpStatusCode == Constants.VALIDATE_OTC_API_RESPONSE.STATUS_CODE_TWO_HUNDRED) {
          this.logger.debugLogs('OTC Validation Response:',this.fileName);
          if (this.rootScope.activeCustTab.otcInsideFTU.hasAccountBalance)
            this.rootScope.activeCustTab.otcInsideFTU.isOTCValidated = true;
          else
            this.updatetoSL4Call();           
        }
        this.rootScope.activeCustTab.otcData.validateOTCApiProcessing = false;

      },
      error: (err) => {
        this.rootScope.activeCustTab.otcData.validateOTCApiProcessing = false;

        const sAuthRes = err?.error?.data;
        this.logger.errorLogs('OTC Validation Error Response:'+JSON.stringify(err),this.fileName);
        if (err?.data?.error_code == Constants.VALIDATE_OTC_API_RESPONSE.STATUS_CODE_FOUR_HUNDRED) {
          this.rootScope.activeCustTab.otcData.otcExpired = true;
          this.oneTimeCode.disable();
        } else if (sAuthRes?.otpAuthstatus == Constants.VALIDATE_OTC_API_RESPONSE.FAIL || sAuthRes?.rsastatus == Constants.VALIDATE_OTC_API_RESPONSE.FAIL) {

          if (sAuthRes?.userStatus == Constants.VALIDATE_OTC_API_RESPONSE.LOCKED) {
            this.rootScope.activeCustTab.otcData.validateOtcLocked = true;
            this.oneTimeCode.disable();
          } else {
            this.rootScope.activeCustTab.otcData.validateOtcFail = true;
          }

        } else {
          this.rootScope.activeCustTab.otcData.validateOtcApiFailure = true;
        }

      }
    })
  }

  /**
   * Below method called when the OTC gets validated from S-Auth and this method
   * the Customer Account from SL2 to SL4 by updating Customer Account Tab Dto and Genesys
   */
  updatetoSL4Call() {
    this.rootScope.activeCustTab.genesysAttributes.CS_AUTH_CD = Constants.AuthMenu.OTC;
    this.rootScope.activeCustTab.otcData.validateOtcSuccess = true;
    this.rootScope.activeCustTab.authenticateStatus = Constants.FULLY_SECURED;
    this.rootScope.activeCustTab.iconClass = this.rootScope.isLiveCall ? 'green' : 'solid green';

    let model = {
      CS_SECURITY_LEVEL: Constants.securityLevels.SL4, authenticateStatus: Constants.FULLY_SECURED,
      iconClass: this.rootScope.isLiveCall ? 'green' : 'solid green',
      domain: this.goToCustomerOverviewPageEmitter
    }

    let body: CallCustomerAttributes = {
      attributes: {
        CS_AUTH_CD: Constants.AuthMenu.OTC,
        CS_SECURITY_LEVEL: Constants.securityLevels.SL4,
        PINV: Constants.PINV_ATTRIBUTES.FULLY_SECURED

      },
    };
    this.apiService.setAccountSecurityDt(model, body);
  }

  updateOtcLength(newLength: number): void {
    this.otcLenght = newLength;

    this.oneTimeCode?.setValidators([
      Validators.required,
      Validators.minLength(this.otcLenght),
      Validators.maxLength(this.otcLenght),
      Validators.pattern(/^\d+$/)
    ]);
    this.oneTimeCode?.updateValueAndValidity();
    this.logger.infoLogs('OTC Length Updated:'+this.otcLenght,this.fileName);
}


/**
 * @param methodsWithData 
 * CCR1-12401
 * This method will handle the preselection of delivery method and its details if there is only one option available for the user to select in step 1.
 * If there is no delivery method available then it will set the flag to show the message to user about missing delivery method data.
 * @author - Sultan Khan
 */
  handlePreselectionOfDeliveryMethod(methodsWithData: any[]) {
    if (methodsWithData?.length == 1 && methodsWithData?.[0]?.details?.length == 1) {
      if (methodsWithData?.[0]?.type == Constants.OTC_MODES.EMAIL) {
        this.rootScope.activeCustTab.otcData.selectedDeliveryMethod = { type: methodsWithData?.[0]?.type, details: methodsWithData?.[0]?.details?.[0] };
        this.rootScope.activeCustTab.otcData.selectedEmail = methodsWithData?.[0]?.details?.[0]?.emailAdress;

      } else if (methodsWithData?.[0]?.type == Constants.OTC_MODES.TEXT) {
        this.rootScope.activeCustTab.otcData.selectedPhoneNumber = methodsWithData?.[0]?.details?.[0]?.phoneNumber;
        this.rootScope.activeCustTab.otcData.selectedCountryCode = methodsWithData?.[0]?.details?.[0]?.countryCode;
        this.rootScope.activeCustTab.otcData.selectedDeliveryMethod = { type: methodsWithData?.[0]?.type, details: methodsWithData?.[0]?.details?.[0] };
      }
    } else if (methodsWithData?.length == 0) {
      this.rootScope.activeCustTab.otcData.deliveryMethodSDataMiss = true;
    }
  }

  /**
   * Calls the Unstop Phone Number Status API for a selected phone entry and updates OTC UI state.
   * Resets success and failure flags before the request, stores the backend status code on a matching
   * phone number entry when successful, and captures a readable error message when the request fails.
   * Story: CCR1-13755 @author - Sultan Khan
   * @param rowData Selected phone row containing country code and phone number.
   */
  unStopPhoneNumberStatus(rowData: any) {
    const payload = {
      mblNmbrFrmtCd: rowData?.countryCode,
      phoneNumber: rowData?.phoneNumber
    };

    const otcData = this.rootScope.activeCustTab?.otcData;
    otcData.unStopPhoneNumberStatusApiSuccess = false;
    otcData.unStopPhoneNumberStatusApiFailure = false;
    otcData.unStopPhoneNumberStatusApiFailureDetails = '';

    this.apiService.unStopPhoneNumberStatus(payload).subscribe({
      next: (res: any) => {
        otcData.unStopPhoneNumberStatusApiSuccess = true;
        const foundDetail = otcData?.phoneNumberStatusList?.find((item: any) => {
          return item?.phoneNumber === rowData?.phoneNumber && item?.mblNmbrFrmtCd === rowData?.countryCode;
        });

        if (foundDetail && res?.data?.statusCode) {
          foundDetail.responseCode = res?.data?.statusCode;
        } else {
          this.rootScope.activeCustTab.otcData.status = res?.data?.statusCode;
        }

        this.logger.debugLogs('Unstop Phone Number Status Response:', this.fileName);
      },
      error: (err: any) => {
        otcData.unStopPhoneNumberStatusApiFailure = true;
        let errorMsg = 'Unknown error occurred';
        try {
          const parsed = JSON.parse(err?.error?.errorResponse?.errorDescription);
          errorMsg = parsed?.message || errorMsg;
        } catch {
          errorMsg = err?.error?.errorResponse?.message || err?.error?.message || errorMsg;
        }
        otcData.unStopPhoneNumberStatusApiFailureDetails = errorMsg;
        this.logger.errorLogs('Error in Unstop Phone Number Status:' + JSON.stringify(err), this.fileName);
      }
    });
  }




}


